<script lang="ts" setup>
defineOptions({name: 'BaseOverlay'});
</script>

<template>
    <!-- Teleported so the layer sits above the whole page regardless of where the host island is
         mounted — the TSD report is one island among several, and the legacy payouts page mounts
         its popup into a throwaway container at the end of body. -->
    <Teleport to="body">
        <div class="merit-overlay">
            <slot />
        </div>
    </Teleport>
</template>

<style scoped>
/* merit- prefix keeps this off the legacy global rules for generic names like .overlay. */
.merit-overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
}
</style>
